// extracted by mini-css-extract-plugin
export default {"slider":"MasterVolume_slider__9Tis5"};